import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FOOTER_GROUPS } from '../data/site';

export default function Alt4Footer() {
  return (
    <footer className="alt4-footer">
      <div className="alt4-container alt4-footer-grid">
        <div className="alt4-footer-brand">
          <Link className="alt4-wordmark alt4-wordmark--footer" to="/alt4">
            <span className="alt4-wordmark-name">asha</span>
            <span className="alt4-wordmark-product">AI-native PMS</span>
          </Link>
          <p>One operating layer for the work that keeps a dental group moving.</p>
          <Link className="alt4-text-link" to="/alt4/walkthrough">
            Book a walkthrough
            <ArrowUpRight size={16} aria-hidden="true" />
          </Link>
        </div>

        {FOOTER_GROUPS.map((group) => (
          <div className="alt4-footer-group" key={group.label}>
            <h2>{group.label}</h2>
            <ul>
              {group.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="alt4-container alt4-footer-bottom">
        <span>Built for the full practice lifecycle.</span>
        <span>AI-native. Governed. Multi-location.</span>
      </div>
    </footer>
  );
}
